import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import './DynamicThreeSixtyWheel.scss';
import { WsAddSegmentButton } from './AddSegmentButton/AddSegmentButton';
import { WsDeleteSegment } from './DeleteSegmentButton/DeleteSegmentButton';
// import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
// import { styled } from '@mui/material/styles';
// import Button from '@mui/material/Button';
// import Dialog from '@mui/material/Dialog';
// import DialogActions from '@mui/material/DialogActions';
// import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
// import DialogTitle from '@mui/material/DialogTitle';

// const WsThreeSixtyWheel = ({ imageLogo, borderColour }) => {
//   const [selectedSegment, setSelectedSegment] = useState(null);
//   const history = useHistory();
//   const [hasBeenClicked, setHasBeenClicked] = useState(false);
//   const [disableAddSegmentButton, setDisableAddSegmentButton] = useState(false);
//   const [alertOpen, setAlertOpen] = useState(true);

//   const [threeSixtyData, setThreeSixtyData] = useState<
//     Array<{
//       sliceLabel: string;
//       sliceBgColour: string;
//       sliceBorderColour: string;
//     }>
//   >([]);

//   const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
//     <Tooltip {...props} classes={{ popper: className }} />
//   ))(({ theme }) => ({
//     [`& .${tooltipClasses.tooltip}`]: {
//       backgroundColor: theme.palette.common.white,
//       color: 'rgba(0, 0, 0, 0.87)',
//       boxShadow: theme.shadows[2],
//       fontSize: 13,
//       fontFamily: 'Segoe UI',
//     },
//   }));

//   useEffect(() => {
//     const storedData = localStorage.getItem('segmentData');
//     if (storedData) {
//       setThreeSixtyData(JSON.parse(storedData));
//     }
//   }, []);

//   useEffect(() => {
//     if (threeSixtyData.length === 10) {
//       setDisableAddSegmentButton(true);
//       setTimeout(() => {
//         setAlertOpen(true);
//       }, 2000);
//     } else {
//       setDisableAddSegmentButton(false);
//     }
//   }, [threeSixtyData]);

//   const handleClose = () => {
//     setAlertOpen(false);
//   };

//   const handleAddSegment = (formData) => {
//     const newSegment = {
//       sliceLabel: formData.sliceLabel,
//       sliceBgColour: formData.sliceBgColour,
//       sliceBorderColour: formData.sliceBorderColour,
//     };
//     setThreeSixtyData((prevData) => [...prevData, newSegment]);
//     localStorage.setItem(
//       'segmentData',
//       JSON.stringify([...threeSixtyData, newSegment])
//     );
//   };

//   const handleDeleteSegment = (segmentName) => {
//     const updatedData = threeSixtyData.filter(
//       (segment) => segment.sliceLabel !== segmentName
//     );
//     setThreeSixtyData(updatedData);
//     localStorage.setItem('segmentData', JSON.stringify(updatedData));
//   };

//   const handleSegmentClick = (index) => {
//     console.log('segment clicked ');
//     history.push('/deliver/decode/databreakdown');
//     setHasBeenClicked(index);
//   };

//   const handleMouseOver = (index) => {
//     setSelectedSegment(index);
//   };

//   const handleMouseOut = () => {
//     //reset changes on mouse out here
//     setSelectedSegment(null);
//   };

//   const totalSegments = threeSixtyData.length;

//   let startAngle = -90; //start from the top (12 o'clock position)

//   const segmentGap = 1;

//   const svgRadius = 220; //radius of the SVG which affects size of cirlce

//   const imageWidth = 200;
//   const imageHeight = 200;

//   const outerBorderColours = threeSixtyData.map(
//     (segment) => segment.sliceBorderColour
//   );

//   const innerRadius = svgRadius - 120;

//   return (
//     <div>
//       <div className='page-heading'>Value Meter (Dynamic)</div>
//       <hr />
//       <div className='btn-container'>
//         <div className='add-seg-btn-container'>
//           <WsAddSegmentButton
//             onAddSegment={handleAddSegment}
//             disabled={disableAddSegmentButton}
//           />
//         </div>

//         <div className='delete-seg-btn-container'>
//           <WsDeleteSegment
//             segmentOptions={threeSixtyData}
//             onDeleteSegment={handleDeleteSegment}
//           />
//         </div>
//       </div>
//       <div className='warning-alert'>
//         {totalSegments >= 10 ? (
//           <div>
//             <Dialog
//               open={alertOpen}
//               onClose={handleClose}
//               aria-labelledby='alert-dialog-title'
//               aria-describedby='alert-dialog-description'
//             >
//               <DialogTitle id='alert-dialog-title' className='dialog-content'>
//                 {'Maximum Reached'}
//               </DialogTitle>
//               <DialogContent>
//                 <DialogContentText
//                   id='alert-dialog-description'
//                   className='dialog-content'
//                 >
//                   You've reached the maximum number of segments.
//                 </DialogContentText>
//               </DialogContent>
//               <DialogActions>
//                 <Button
//                   className='cancel-btn'
//                   variant='outlined'
//                   onClick={handleClose}
//                 >
//                   Close
//                 </Button>
//               </DialogActions>
//             </Dialog>
//           </div>
//         ) : (
//           ''
//         )}
//       </div>
//       {threeSixtyData.length <= 0 ? (
//         <div className='info-text'>
//           You currently have no data in your 360° Value Meter. Please click on
//           'Add Segment' to get started.
//         </div>
//       ) : (
//         ''
//       )}

//       <div className='three-sixty-wheel-container'>
//         {totalSegments === 1 ? (
//           <svg
//             width={svgRadius * 2 + 150}
//             height={svgRadius * 2 + 150}
//             className='wheel-svg'
//             viewBox='-80 20 600 400'
//           >
//             <circle
//               cx={svgRadius}
//               cy={svgRadius}
//               r={svgRadius + 10}
//               fill={'#ffffff'}
//               stroke={threeSixtyData[0].sliceBorderColour}
//               strokeWidth='8'
//               onMouseOver={() => handleMouseOver(threeSixtyData[0])}
//               onMouseOut={handleMouseOut}
//               onClick={() => handleSegmentClick(threeSixtyData[0])}
//             />
//             <LightTooltip
//               key={threeSixtyData[0].sliceLabel}
//               title={threeSixtyData[0].sliceLabel}
//               className='tooltip-txt'
//               followCursor
//             >
//               <circle
//                 cx={svgRadius}
//                 cy={svgRadius}
//                 r={svgRadius}
//                 fill={threeSixtyData[0].sliceBgColour}
//                 stroke={'ffffff'}
//                 className='circle-for-one-seg'
//                 strokeWidth='8'
//                 onMouseOver={() => handleMouseOver(threeSixtyData[0])}
//                 onMouseOut={handleMouseOut}
//                 onClick={() => handleSegmentClick(threeSixtyData[0])}
//               />
//             </LightTooltip>
//             <text
//               x={50}
//               y={200}
//               fill='black'
//               textAnchor='middle'
//               dominantBaseline='middle'
//               className='tooltip-txt'
//             >
//               {threeSixtyData[0].sliceLabel}
//             </text>
//             <circle
//               cx={svgRadius}
//               cy={svgRadius}
//               r={120}
//               fill={'#ffffff'}
//               stroke={'#ffffff'}
//             />
//             <image
//               x={svgRadius - imageWidth / 2}
//               y={svgRadius - imageHeight / 2}
//               width={imageWidth}
//               height={imageHeight}
//               xlinkHref={imageLogo}
//               className='center-image'
//               style={{
//                 zIndex: 2,
//                 borderRadius: '50%',
//                 clipPath: `circle(${innerRadius}px at center)`,
//               }}
//             />
//           </svg>
//         ) : (
//           <svg
//             width={svgRadius * 2 + 150}
//             height={svgRadius * 2 + 150}
//             className='wheel-svg'
//             viewBox='-80 20 600 400'
//           >
//             ;{/* Segmented outer border with colours*/}
//             {threeSixtyData.map((segment, index) => {
//               startAngle += segmentGap;
//               const endAngle = startAngle + 360 / totalSegments - segmentGap;
//               const pathData = describeArc(
//                 svgRadius,
//                 svgRadius,
//                 svgRadius + 20,
//                 innerRadius,
//                 startAngle,
//                 endAngle
//               );

//               startAngle = endAngle;

//               return (
//                 <path
//                   key={index}
//                   d={pathData}
//                   fill={outerBorderColours[index]}
//                   stroke='#ffffff'
//                   strokeWidth='8'
//                   className={`segment ${
//                     selectedSegment === index ? 'isHovered' : ''
//                   }`}
//                   transform={`translate(0, ${
//                     selectedSegment === index ? -10 : 0
//                   })`}
//                   onMouseOver={() => handleMouseOver(index)}
//                   onMouseOut={handleMouseOut}
//                 />
//               );
//             })}
//             {/* Circular outer-most border - it needs to accomodate for sub segments in the future */}
//             {/* <circle
//               cx={svgRadius}
//               cy={svgRadius}
//               r={svgRadius + 40}
//               fill='none'
//               stroke={borderColour}
//               strokeWidth='1'
//             /> */}
//             {threeSixtyData.map((segment, index) => {
//               startAngle += segmentGap;
//               const endAngle = startAngle + 360 / totalSegments - segmentGap;
//               const midAngle = startAngle + 360 / totalSegments / 2;
//               const pathData = describeArc(
//                 svgRadius,
//                 svgRadius,
//                 svgRadius,
//                 innerRadius,
//                 startAngle,
//                 endAngle
//               );

//               startAngle = endAngle;

//               const labelRadius = 180;

//               const labelX =
//                 svgRadius + labelRadius * Math.cos((midAngle * Math.PI) / 180);
//               const labelY =
//                 svgRadius + labelRadius * Math.sin((midAngle * Math.PI) / 180);

//               let rotationAngle = midAngle - 90; //rotating text

//               //calculation to rotate labels for segments where label is upside down
//               if (index === 0 || index === 1 || index === 5 || index === 4) {
//                 rotationAngle += 180; //add 180 degrees to make labels more upright
//               }

//               return (
//                 <g key={index}>
//                   <LightTooltip
//                     key={index}
//                     title={segment.sliceLabel}
//                     followCursor
//                   >
//                     <path
//                       d={pathData}
//                       fill={segment.sliceBgColour}
//                       stroke='#ffffff'
//                       strokeWidth='8'
//                       className={`segment ${
//                         selectedSegment === index ? 'isHovered' : ''
//                       }`}
//                       onMouseOver={() => handleMouseOver(index)}
//                       onMouseOut={handleMouseOut}
//                       onClick={() => handleSegmentClick(index)}
//                     />
//                   </LightTooltip>
//                   <text
//                     x={labelX}
//                     y={labelY}
//                     fill='black'
//                     textAnchor='middle'
//                     dominantBaseline='middle'
//                     className='tooltip-txt'
//                     transform={`rotate(${rotationAngle} ${labelX} ${labelY})`}
//                   >
//                     {segment.sliceLabel}
//                   </text>
//                   {/* Render image in the center of the wheel, however each path is rendering
//               this image so it's not an ideal solution */}
//                   <circle
//                     cx={svgRadius}
//                     cy={svgRadius}
//                     r={120}
//                     fill={'#ffffff'}
//                     stroke={'#ffffff'}
//                   />
//                   <image
//                     x={svgRadius - imageWidth / 2}
//                     y={svgRadius - imageHeight / 2}
//                     width={imageWidth}
//                     height={imageHeight}
//                     xlinkHref={imageLogo}
//                     className='center-image'
//                     style={{
//                       zIndex: 2,
//                       clipPath: `circle(${innerRadius}px at center)`,
//                     }}
//                   />
//                   ;
//                 </g>
//               );
//             })}
//           </svg>
//         )}
//       </div>
//     </div>
//   );
// };

// //calculate the SVG path of a circular arc including an inner radius
// function describeArc(x, y, outerRadius, innerRadius, startAngle, endAngle) {
//   const startRadians = (startAngle * Math.PI) / 180;
//   const endRadians = (endAngle * Math.PI) / 180;

//   const startXOuter = x + outerRadius * Math.cos(startRadians);
//   const startYOuter = y + outerRadius * Math.sin(startRadians);

//   const endXOuter = x + outerRadius * Math.cos(endRadians);
//   const endYOuter = y + outerRadius * Math.sin(endRadians);

//   const startXInner = x + innerRadius * Math.cos(startRadians);
//   const startYInner = y + innerRadius * Math.sin(startRadians);

//   const endXInner = x + innerRadius * Math.cos(endRadians);
//   const endYInner = y + innerRadius * Math.sin(endRadians);

//   const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';

//   return `M ${startXOuter} ${startYOuter}
//           A ${outerRadius} ${outerRadius} 0 ${largeArcFlag} 1 ${endXOuter} ${endYOuter}
//           L ${endXInner} ${endYInner}
//           A ${innerRadius} ${innerRadius} 0 ${largeArcFlag} 0 ${startXInner} ${startYInner}
//           Z`;
// }


const WsThreeSixtyWheel = ({ imageLogo, borderColour }) => {
  return null;
};

export { WsThreeSixtyWheel };
